import { createAction } from 'redux-actions';
import { createRoutine } from 'redux-saga-routines';
import {
  SNOWFLAKE_DOWNLOAD_REPORT,
  SNOWFLAKE_GET_FIRST_TIMERS,
  SNOWFLAKE_GET_LOCATIONS,
  SNOWFLAKE_GET_STATS,
  SNOWFLAKE_GET_TERMINATED_MEMBERS,
  SNOWFLAKE_SET_DATE_RANGE,
  SNOWFLAKE_SET_LOCATION,
} from './types';

export const snowflakeGetStats = createRoutine(SNOWFLAKE_GET_STATS);
export const snowflakeGetFirstTimers = createRoutine(
  SNOWFLAKE_GET_FIRST_TIMERS
);
export const snowflakeGetTerminatedMembers = createRoutine(
  SNOWFLAKE_GET_TERMINATED_MEMBERS
);
export const snowflakeGetLocations = createRoutine(SNOWFLAKE_GET_LOCATIONS);
export const snowflakeSetDateRange = createAction(SNOWFLAKE_SET_DATE_RANGE);
export const snowflakeSetLocation = createAction(SNOWFLAKE_SET_LOCATION);
export const snowflakeDownloadReport = createRoutine(SNOWFLAKE_DOWNLOAD_REPORT);
